#import '../../../../../common/components/DocumentPackageEmail/EmailDocumentFields.graphql'
#import "../../../../../common/components/DocumentPackageEmail/EntityEmailDocumentsFields.graphql"

query TravelPlanEmailStatus($id: UUID!) {
  travelAuthorization(id: $id) {
    __typename
    id
    _rowTimestamp
     _planEmailDocument {
      ...EmailDocumentFields
    }
      travelPlanEmailDocumentsByEntityId: emailDocumentsByEntityId(
      orderBy: [_CREATED_DATE_DESC, PRIMARY_KEY_ASC]
      filter: { _isTravelPlanEmail: { equalTo: true } }
    ) {
      nodes {
        ...EntityEmailDocumentsFields
      }
    }
  }
}
